import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    loading: -1,
    finishing: -1,
    updating: -1,
    accepting: -1,
    loadPending: -1,
    loadPendingStats: -1,
    acceptPending: -1,
    detailsInPool: -1,
    ongoingConsult: -1,
    setMainProvider: -1,
    loadConsultationClinic: -1,
    genClinicalNote: -1,
    switchConsultToOtherClinic: -1,
    loadPatient: -1,
  },
  id: '',
  ongoingConsult: null,
  consultDetail: null,
  setMainProvider: null,
  pendingIds: [],
  hasLoadmorePending: false,
  pendingStats: { total: 0 },
  pendingId: -1,
  pendingConsultActive: -1,
  pendingDetailsId: -1,
  genClinicalNote: null,
  metaPending: {
    pagination: {
      page: 1,
    },
  },
  members: {},
  consultationClinic: null,
  patient: null,
  error: null,
  errorGenClinicalNote: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case ACTION_TYPES.CONSULT_DETAILS_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loading: 0,
        },
      };
    case ACTION_TYPES.CONSULT_DETAILS_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          loading: 1,
        },
        id: payload.result.data,
        consultDetail: payload.data,
      };
    case ACTION_TYPES.CONSULT_DETAILS_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loading: 2,
        },
        error,
      };
    case ACTION_TYPES.CONSULT_FINISH_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          finishing: 0,
        },
      };
    case ACTION_TYPES.CONSULT_FINISH_SUCCEED:
      return {
        ...state,
        // id: payload.data.result,
        status: {
          ...state.status,
          finishing: 1,
        },
      };
    case ACTION_TYPES.CONSULT_FINISH_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          finishing: 2,
        },
        error,
      };
    case ACTION_TYPES.CONSULT_GET_ONGOING_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          ongoingConsult: 0,
        },
      };
    case ACTION_TYPES.CONSULT_GET_ONGOING_SUCCEED:
      return {
        ...state,
        ongoing: payload.data,
        status: {
          ...state.status,
          ongoingConsult: 1,
        },
      };
    case ACTION_TYPES.CONSULT_GET_ONGOING_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          ongoingConsult: 2,
        },
        error,
      };
    case ACTION_TYPES.CONSULT_UPDATE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          updating: 0,
        },
      };
    case ACTION_TYPES.CONSULT_UPDATE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          updating: 1,
        },
      };
    case ACTION_TYPES.CONSULT_UPDATE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          updating: 2,
        },
        error,
      };
    case ACTION_TYPES.CONSULT_ACCEPT_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          accepting: 0,
        },
      };
    case ACTION_TYPES.CONSULT_ACCEPT_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          accepting: 1,
        },
      };
    case ACTION_TYPES.CONSULT_ACCEPT_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          accepting: 2,
        },
        error,
      };

    case ACTION_TYPES.CONSULTS_PENDING_GET_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadPending: 0,
        },
      };
    case ACTION_TYPES.CONSULTS_PENDING_GET_SUCCEED: {
      const { isLoadMore } = action.meta;
      const { data, meta } = payload.result;
      return {
        ...state,
        status: {
          ...state.status,
          loadPending: 1,
        },
        pendingIds: isLoadMore ? [...new Set([...state.pendingIds, ...data])] : data,
        metaPending: meta,
        hasLoadmorePending: meta.pagination.pageSize === data.length,
      };
    }
    case ACTION_TYPES.CONSULTS_PENDING_GET_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadPending: 2,
        },
        error,
      };

    case ACTION_TYPES.CONSULTS_PENDING_STATS_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadPendingStats: 0,
        },
      };
    case ACTION_TYPES.CONSULTS_PENDING_STATS_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          loadPendingStats: 1,
        },
        pendingStats: payload.data,
      };
    case ACTION_TYPES.CONSULTS_PENDING_STATS_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadPendingStats: 2,
        },
        error,
      };

    case ACTION_TYPES.CONSULT_PENDING_ACCEPT_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          acceptPending: 0,
        },
      };
    case ACTION_TYPES.CONSULT_PENDING_ACCEPT_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          acceptPending: 1,
        },
        pendingId: payload.result.data,
      };
    case ACTION_TYPES.CONSULT_PENDING_ACCEPT_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          acceptPending: 2,
        },
        error,
      };

    case ACTION_TYPES.CONSULT_PENDING_RESET_STATE: {
      return {
        ...state,
        status: {
          ...state.status,
          acceptPending: -1,
          detailsInPool: -1,
        },
        pendingIds: [],
      };
    }

    case ACTION_TYPES.CONSULT_PENDING_REMOVE: {
      return {
        ...state,
        pendingIds: state.pendingIds.filter(id => id !== payload),
      };
    }

    case ACTION_TYPES.CONSULT_PENDING_ADDED: {
      return {
        ...state,
        pendingIds: [...new Set([payload, ...state.pendingIds])],
      };
    }

    case ACTION_TYPES.CONSULT_PENDING_STATS_INCREASE_TOTAL: {
      return {
        ...state,
        pendingStats: {
          ...state.pendingStats,
          total: (state.pendingStats?.total || 0) + payload,
        },
      };
    }

    case ACTION_TYPES.CONSULT_PENDING_STATS_DECREASE_TOTAL: {
      return {
        ...state,
        pendingStats: {
          ...state.pendingStats,
          total: (state.pendingStats?.total || 0) - payload,
        },
      };
    }

    case ACTION_TYPES.CONSULT_DETAILS_POOL_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          detailsInPool: 0,
        },
      };
    case ACTION_TYPES.CONSULT_DETAILS_POOL_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          detailsInPool: 1,
        },
        pendingDetailsId: payload.result.data,
      };
    case ACTION_TYPES.CONSULT_STATUS_RESET_STATE:
      return {
        ...state,
        status: {
          ...state.status,
          accepting: -1,
          acceptPending: -1,
          finishing: -1,
        },
        error: null,
      };
    case ACTION_TYPES.CONSULT_MEMBER_GET_SUCCEED: {
      const { consultId } = action.meta;
      return {
        ...state,
        members: { ...state.members, [consultId]: payload.data },
      };
    }

    case ACTION_TYPES.CONSULT_CREATE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          create: 0,
        },
      };

    case ACTION_TYPES.CONSULT_CREATE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          create: 1,
        },
      };
    case ACTION_TYPES.CONSULT_CREATE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          create: 2,
        },
        error,
      };

    case ACTION_TYPES.CONSULT_SET_MAIN_PROVIDER_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          setMainProvider: 0,
        },
      };

    case ACTION_TYPES.CONSULT_SET_MAIN_PROVIDER_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          setMainProvider: 1,
        },
      };
    case ACTION_TYPES.CONSULT_SET_MAIN_PROVIDER_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          setMainProvider: 2,
        },
        error: {
          ...state.error,
          setMainProvider: error,
        },
      };

    // getConsultationClinic
    case ACTION_TYPES.CONSULTATION_CLINIC_GET_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadConsultationClinic: 0,
        },
      };

    case ACTION_TYPES.CONSULTATION_CLINIC_GET_SUCCEEDED:
      return {
        ...state,
        status: {
          ...state.status,
          loadConsultationClinic: 1,
        },
        consultationClinic: payload.data,
      };

    case ACTION_TYPES.CONSULTATION_CLINIC_GET_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadConsultationClinic: 2,
        },
      };

    case ACTION_TYPES.CONSULT_GEN_CLINICAL_NOTE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          genClinicalNote: 0,
        },
        errorGenClinicalNote: null,
      };

    case ACTION_TYPES.CONSULT_GEN_CLINICAL_NOTE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          genClinicalNote: 1,
        },
        genClinicalNote: payload.data,
      };
    case ACTION_TYPES.CONSULT_GEN_CLINICAL_NOTE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          genClinicalNote: 2,
        },
        errorGenClinicalNote: error,
      };
    case ACTION_TYPES.CONSULT_PENDING_ACTIVE:
      return {
        ...state,
        pendingConsultActive: payload,
      };

    // switchConsultToOtherClinic
    case ACTION_TYPES.CONSULT_SWITCH_TO_OTHER_CLINIC_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          switchConsultToOtherClinic: 0,
        },
        error: {
          ...state.error,
          switchConsultToOtherClinic: null,
        },
      };

    case ACTION_TYPES.CONSULT_SWITCH_TO_OTHER_CLINIC_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          switchConsultToOtherClinic: 1,
        },
        error: {
          ...state.error,
          switchConsultToOtherClinic: null,
        },
      };

    case ACTION_TYPES.CONSULT_SWITCH_TO_OTHER_CLINIC_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          switchConsultToOtherClinic: 2,
        },
        error: {
          ...state.error,
          switchConsultToOtherClinic: error,
        },
      };

    case ACTION_TYPES.CONSULT_SWITCH_TO_OTHER_CLINIC_RESET_STATE:
      return {
        ...state,
        status: {
          ...state.status,
          switchConsultToOtherClinic: -1,
        },
        error: {
          ...state.error,
          switchConsultToOtherClinic: null,
        },
      };

    case ACTION_TYPES.CONSULT_RESET_STATE:
      return initialState;

    case ACTION_TYPES.CONSULT_PATIENT_GET_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadPatient: 0,
        },
      };

    case ACTION_TYPES.CONSULT_PATIENT_GET_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          loadPatient: 1,
        },
        patient: payload.data,
      };

    case ACTION_TYPES.CONSULT_PATIENT_GET_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadPatient: 2,
        },
        error: {
          ...state.error,
          patient: error,
        },
      };

    default:
      return state;
  }
}
